const b64ToBytes = (v) => {
  const raw = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw], (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isInstalled = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const needsHomeScreen = () => isIOS() && !isInstalled();

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush(api) {
  if (needsHomeScreen()) throw new Error("On iPhone or iPad, add the portal to your Home Screen first (Share → Add to Home Screen), then open it from there.");
  if (!pushSupported()) throw new Error("This browser doesn't support push notifications.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications are blocked for this site. Allow them in your browser's site settings.");
  const reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.public_key) }));
  await api.put("/push/subscription", sub.toJSON());
  return sub;
}

export async function disablePush(api) {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}

export async function syncPush(api) {
  const sub = Notification.permission === "granted" ? await currentSubscription() : null;
  if (sub) await api.put("/push/subscription", sub.toJSON());
}
